import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

export const CancelSubmissionParamsValidationSchema = z.object({
  submissionId: ObjectIdStringValidationSchema.meta({
    description: 'The ID of the form submission to cancel.',
  }),
});

export const CancelSubmissionRequestBodyValidationSchema = z
  .object({
    reason: z.string().trim().min(1).max(500).meta({
      description:
        'Why the submission is being canceled. Stored on the submission and returned as `canceledReason`. Canceling is final and cannot be undone.',
    }),
    sendCancellationEmail: z.boolean().optional().meta({
      description:
        'When `true`, emails the customer that their submission has been canceled. Defaults to `false`.',
    }),
  })
  .strict()
  .meta({
    description:
      'Cancels a form submission. A cancel is final and cannot be undone. A canceled submission no longer counts toward "Prevent duplicate submissions", so the same customer can submit the form again, and its files leave the customer portal. A submission that is already canceled returns 400.',
  });
